import React from "react"
import { Box } from "@chakra-ui/react"

type Props = {
  children: React.ReactNode
  onBackdropClick?: () => void
}

const BuilderContentArea = ({ children, onBackdropClick }: Props) => (
  <Box position="relative" pb={40} overflow="hidden" minHeight="30rem">
    <Box
      position="absolute"
      height="full"
      top={0}
      right={0}
      bottom={0}
      left={0}
      onClick={onBackdropClick}
    />
    <Box w={700} margin="auto" pt={8}>
      {children}
    </Box>
  </Box>
)

export default BuilderContentArea
